import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { OAuthHttpClient } from '../../services/o-auth-http-client';
import { OAuthAuthorizeActions } from './o-auth-authorize.actions';

@Injectable({ providedIn: 'root' })
export class OAuthAuthorizeEffects {
  public authorize$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OAuthAuthorizeActions.authorize),
      switchMap(({ payload }) =>
        this.oAuthHttpClient.authorize(payload).pipe(
          map(data => OAuthAuthorizeActions.authorizeSuccess({ payload: data })),
          catchError((error: HttpErrorResponse) =>
            of(OAuthAuthorizeActions.authorizeFailed({ payload: { error } })),
          ),
        ),
      ),
    ),
  );

  public deauthorize$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OAuthAuthorizeActions.deauthorize),
      switchMap(({ payload }) =>
        this.oAuthHttpClient.deauthorize(payload.clientId).pipe(
          map(() => OAuthAuthorizeActions.deauthorizeSuccess()),
          catchError((error: HttpErrorResponse) =>
            of(OAuthAuthorizeActions.deauthorizeFailed({ payload: { error } })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private oAuthHttpClient: OAuthHttpClient,
  ) {}
}
